import { ITypeOption } from "@/components/excel/schema/definiens/bizType";

import {
  ProvinceMode,
  CityMode,
  CountyMode,
  ProvinceCityMode,
  CityCountyMode,
  ProvinceCityCountyMode,
} from "@/components/excel/schema/value/mode/area";
const base = 200;
const ProvinceOption: ITypeOption = {
  value: base + 1,
  text: "省",
  mode: ProvinceMode,
};
const CityOption: ITypeOption = {
  value: base + 2,
  text: "市",
  mode: CityMode,
  parent: ProvinceOption,
};
ProvinceOption.child = CityOption;
const CountyOption: ITypeOption = {
  value: base + 3,
  text: "区/县",
  mode: CountyMode,
  parent: CityOption,
};
CityOption.child = CountyOption;
const ProvinceCityOption: ITypeOption = {
  value: base + 4,
  text: "省-市",
  mode: ProvinceCityMode,
};
ProvinceCityOption.child = CountyOption;
const CityCountyOption: ITypeOption = {
  value: base + 5,
  text: "市-区/县",
  mode: CityCountyMode,
  parent: ProvinceOption,
};
const ProvinceCityCountyOption: ITypeOption = {
  value: base + 6,
  text: "省-市-区/县",
  mode: ProvinceCityCountyMode,
};
export {
  ProvinceOption,
  CityOption,
  CountyOption,
  ProvinceCityOption,
  CityCountyOption,
  ProvinceCityCountyOption,
};
